const helpCenter = {
  Distributor: 'Distribuidor',
  'Distributor requests': 'Solicitudes del distribuidor',
  'Direct MedEffects request': 'Solicitud directa de MedEffects',
  'Read-only access. Requests and attachments can be viewed; messaging is unavailable.':
    'Acceso de solo lectura. Puede consultar solicitudes y archivos; no se pueden enviar mensajes.',
  'Your requests and clinic requests are shared with MedEffects admins.':
    'Sus solicitudes y las de sus cl\u00ednicas se comparten con los administradores de MedEffects.',
  'Your conversation is shared with your distributor and MedEffects admins. Other clinics cannot see it.':
    'Su conversaci\u00f3n se comparte con su distribuidor y los administradores de MedEffects. Otras cl\u00ednicas no pueden verla.',
  'All direct and distributor requests appear in this inbox. Every reply is shared with conversation participants.':
    'Esta bandeja incluye todas las solicitudes directas y de distribuidores. Cada respuesta se comparte con los participantes de la conversaci\u00f3n.',
  'Requests from clinics, distributors and sales reps will appear here.':
    'Las solicitudes de cl\u00ednicas, distribuidores y representantes aparecer\u00e1n aqu\u00ed.',
  'This conversation is no longer available to your account.':
    'Esta conversaci\u00f3n ya no est\u00e1 disponible para su cuenta.',
  'This request is resolved. Contact support to reopen it.':
    'Esta solicitud est\u00e1 resuelta. Contacte con soporte para reabrirla.',
  'Replies are unavailable for this request.':
    'Las respuestas no est\u00e1n disponibles para esta solicitud.',
  'Opening attachment...': 'Abriendo archivo adjunto...',

  'Welcome to your new Help Center': 'Te damos la bienvenida a tu nuevo Centro de ayuda',
  'Need a hand? Send a message directly to MedEffects admins, attach files or photos, and follow every reply here.':
    '¿Necesitas ayuda? Envía un mensaje directamente a los administradores de MedEffects, adjunta archivos o fotos y consulta todas las respuestas aquí.',
  'Support hours: Monday–Friday, 8 AM–5 PM Central.':
    'Horario de atención: lunes a viernes, de 8 a. m. a 5 p. m., hora central.',
  'Got it': 'Entendido',
  'Keyword, ID, name or email': 'Palabra, ID, nombre o correo',
  'Keyword or Help ID': 'Palabra clave o ID',
  'Search subjects, messages, Help IDs, names or emails.':
    'Buscar asuntos, mensajes, ID, nombres o correos.',
  'Search subjects, messages or Help IDs.': 'Buscar asuntos, mensajes o ID de ayuda.',
  'Clear search': 'Borrar b\u00fasqueda',
  'No matching requests': 'No hay solicitudes coincidentes',
  'Try another keyword or Help ID, or change your filters.':
    'Pruebe otra palabra o ID, o cambie los filtros.',
  'Requests from clinics and sales reps will appear here.':
    'Las solicitudes de cl\u00ednicas y representantes de ventas aparecer\u00e1n aqu\u00ed.',
  'Select a request to read and reply to the conversation.':
    'Seleccione una solicitud para leer y responder a la conversaci\u00f3n.',
  'Dismiss notification': 'Cerrar aviso',
  Clinic: 'Cl\u00ednica',
  'Sales Rep': 'Representante de ventas',
  Admin: 'Administrador',
  'Help Center': 'Centro de ayuda',
  Navigation: 'Navegación',
  'Messages and support, all in one place.': 'Mensajes y asistencia en un solo lugar.',
  'A little help, right here': 'La ayuda que necesita, aquí',
  'Add date': 'Agregar fecha',
  'Add your message or a ready attachment, and complete all required fields.':
    'Agregue un mensaje o un archivo listo y complete los campos obligatorios.',
  'All admins': 'Todos los administradores',
  'Assigned admin': 'Administrador asignado',
  'Assigned to me': 'Asignados a mí',
  'Assignment filter': 'Filtrar asignación',
  'Attach files or photos': 'Adjuntar archivos o fotos',
  'Attachment preview': 'Vista previa del archivo',
  'Attachments are temporarily unavailable. You can still send a text message.':
    'Los archivos adjuntos no están disponibles temporalmente. Puede enviar un mensaje de texto.',
  'Back to requests': 'Volver a las solicitudes',
  Category: 'Categoría',
  'Central Time': 'Hora central',
  'Choose a request to read the conversation, or start a new one.':
    'Elija una solicitud para leer la conversación o cree una nueva.',
  'Choose up to {count} attachments.': 'Elija hasta {count} archivos adjuntos.',
  Close: 'Cerrar',
  'Close preview': 'Cerrar vista previa',
  'Closed dates': 'Fechas sin atención',
  'Closes at': 'Hora de cierre',
  'Could not load requests. Refresh to try again.':
    'No se pudieron cargar las solicitudes. Actualice para volver a intentarlo.',
  'Could not load support admins. Refresh to try again.':
    'No se pudieron cargar los administradores. Actualice para volver a intentarlo.',
  'Could not load this conversation. Refresh to try again.':
    'No se pudo cargar esta conversación. Actualice para volver a intentarlo.',
  'Could not open this attachment. Please try again.':
    'No se pudo abrir este archivo. Inténtelo de nuevo.',
  'Could not refresh. Please try again.': 'No se pudo actualizar. Inténtelo de nuevo.',
  Download: 'Descargar',
  'Help Center messaging is temporarily unavailable. Please use the contact options below.':
    'Los mensajes del Centro de ayuda no están disponibles temporalmente. Utilice las opciones de contacto que aparecen abajo.',
  'Help Center views': 'Vistas del Centro de ayuda',
  'How can we help?': '¿Cómo podemos ayudarle?',
  'Load more requests': 'Cargar más solicitudes',
  'Loading conversation…': 'Cargando conversación…',
  'Loading requests…': 'Cargando solicitudes…',
  'Manage support hours': 'Administrar horario de atención',
  'MedEffects support': 'Asistencia de MedEffects',
  Message: 'Mensaje',
  Messages: 'Mensajes',
  'My requests': 'Mis solicitudes',
  'New messages ↓': 'Mensajes nuevos ↓',
  'New request': 'Nueva solicitud',
  'No requests here yet': 'Todavía no hay solicitudes',
  'Open attachment': 'Abrir archivo adjunto',
  'Opens at': 'Hora de apertura',
  'Other ways to reach us': 'Otras formas de contactarnos',
  'PDF attachment': 'Archivo PDF adjunto',
  Photo: 'Foto',
  'Preview hours': 'Vista previa del horario',
  'Preview the schedule before saving. Requests can always be sent after hours.':
    'Revise el horario antes de guardarlo. Las solicitudes se pueden enviar fuera del horario de atención.',
  Refresh: 'Actualizar',
  Remove: 'Quitar',
  'Remove {name}': 'Quitar {name}',
  'Reply & resolve': 'Responder y resolver',
  'Request received. You can follow replies here.':
    'Solicitud recibida. Puede ver las respuestas aquí.',
  'Request {reference} received.': 'Solicitud {reference} recibida.',
  'Request status': 'Estado de la solicitud',
  Requester: 'Solicitante',
  'Retry upload': 'Reintentar carga',
  Search: 'Buscar',
  'Search requests': 'Buscar solicitudes',
  'Selected photo': 'Foto seleccionada',
  'Send anytime. Support reopens {time}.': 'Envíe cuando quiera. La atención se reanuda el {time}.',
  Sent: 'Enviado',
  'Start a request': 'Crear una solicitud',
  'Start a request whenever you need a hand.': 'Cree una solicitud cuando necesite ayuda.',
  Subject: 'Asunto',
  'Support contact information': 'Información de contacto de asistencia',
  'Support hours': 'Horario de atención',
  'Support hours are unavailable. Please refresh.':
    'El horario no está disponible. Actualice la página.',
  'Support hours saved.': 'Horario de atención guardado.',
  'Support hours settings': 'Configuración del horario de atención',
  'Support inbox': 'Bandeja de asistencia',
  'Tell us what you need. MedEffects admins will reply here.':
    'Cuéntenos qué necesita. Los administradores de MedEffects responderán aquí.',
  'This message is locked until its send status is confirmed. Retry uses the same message ID.':
    'Este mensaje está bloqueado hasta confirmar su envío. El reintento utiliza el mismo identificador.',
  'Time zone': 'Zona horaria',
  Unassigned: 'Sin asignar',
  'Unsaved schedule preview': 'Vista previa del horario sin guardar',
  'Up to 5 files · 5 MB each · JPG, PNG, PDF': 'Hasta 5 archivos · 5 MB cada uno · JPG, PNG, PDF',
  'Updates paused. Check your connection or refresh. Your draft is preserved.':
    'Actualizaciones en pausa. Revise la conexión o actualice. Su borrador se conserva.',
  'Upload progress': 'Progreso de carga',
  'Use JPG, PNG, or PDF files up to 5 MB each. HEIC photos must first be converted to JPG or PNG.':
    'Use archivos JPG, PNG o PDF de hasta 5 MB. Primero convierta las fotos HEIC a JPG o PNG.',
  'Working days': 'Días de atención',
  'You can send a message now. The next opening is not scheduled.':
    'Puede enviar un mensaje ahora. La próxima apertura no está programada.',
  '{count} requests': '{count} solicitudes',
  '1 request': '1 solicitud',
  '{count} unread': '{count} sin leer',
  'Needs support': 'Necesita asistencia',
  'Waiting on user': 'Esperando al usuario',
  Resolved: 'Resuelta',
  'Orders & shipping': 'Pedidos y envíos',
  Billing: 'Facturación',
  'Account access': 'Acceso a la cuenta',
  'Technical issue': 'Problema técnico',
  Other: 'Otro',
  Ready: 'Listo',
  'Upload failed': 'Error de carga',
  Uploading: 'Cargando',
  'This request changed. Refresh the conversation before trying again. Your draft is preserved.':
    'Esta solicitud cambió. Actualice la conversación antes de reintentar. Su borrador se conserva.',
  'Message not confirmed. Your draft is preserved. Retry to safely check and send the same message.':
    'El mensaje no está confirmado. Su borrador se conserva. Reintente para verificar y enviar el mismo mensaje.',
  'Sending…': 'Enviando…',
  'Retry message': 'Reintentar mensaje',
  'Send request': 'Enviar solicitud',
  'Send reply': 'Enviar respuesta',
  Reply: 'Respuesta',
  'Within support hours': 'Dentro del horario de atención',
  'Outside support hours': 'Fuera del horario de atención',
  Sun: 'Dom',
  Mon: 'Lun',
  Tue: 'Mar',
  Wed: 'Mié',
  Thu: 'Jue',
  Fri: 'Vie',
  Sat: 'Sáb',
  'Support hours changed. Close and reload before saving your changes.':
    'El horario cambió. Cierre y vuelva a cargar antes de guardar.',
  'Could not update support hours. Check the schedule and try again.':
    'No se pudo actualizar el horario. Revíselo e inténtelo de nuevo.',
  'Please wait…': 'Espere…',
  'Save hours': 'Guardar horario',
  'Could not save this change. Refresh and try again.':
    'No se pudo guardar el cambio. Actualice e inténtelo de nuevo.',
  'Open requests': 'Solicitudes abiertas',
  'All requests': 'Todas las solicitudes',
  Conversation: 'Conversación',
  'Reopen request': 'Reabrir solicitud',
  'Resolve request': 'Resolver solicitud',
};

export default helpCenter;
